import { SyntheticEvent } from 'react'
import { GridFilterCellProps } from '@progress/kendo-react-grid'

import { Option, Select } from '../../Select'
import { OptionsProps } from './types'

type BooleanFilterCellProps = {
  options?: OptionsProps
}

export const booleanFilterCell =
  ({ options }: BooleanFilterCellProps) =>
  (props: GridFilterCellProps): JSX.Element => <BooleanFilterCell {...props} options={options} />

type BooleanValue = string
type BooleanFilterCellComponentProps = {
  options?: OptionsProps
} & GridFilterCellProps

export const BooleanFilterCell: React.FC<BooleanFilterCellComponentProps> = (props) => {
  const operator = (value: BooleanValue, booleanValue: BooleanValue) => {
    if (booleanValue === value.toString()) {
      return true
    }
    return false
  }

  const operatorDefault = () => {
    return 'none'
  }

  const handleChange = (value: BooleanValue) => {
    props.onChange({
      value: value || undefined,
      operator: getOperator(value),
      syntheticEvent: undefined as unknown as SyntheticEvent<unknown, Event>,
    })
  }

  const getOperator = (value: BooleanValue) => {
    const fnOperator = value ? operator : operatorDefault
    return props?.options?.operator ? props.options.operator : fnOperator
  }

  return (
    <Select
      placeholder='Select ...'
      defaultValue={undefined}
      onChange={handleChange}
      allowClear
      style={{ width: '100%' }}
    >
      <Option key='true' value='true'>
        {'true'}
      </Option>
      <Option key='false' value='false'>
        {'false'}
      </Option>
    </Select>
  )
}
